/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_And_ConditionsInputs */

const en_terms_and_conditions = /** @type {(inputs: Terms_And_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms and Conditions`)
};

const th_terms_and_conditions = /** @type {(inputs: Terms_And_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อกำหนดและเงื่อนไข`)
};

const ja_terms_and_conditions = /** @type {(inputs: Terms_And_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用規約`)
};

const fr_terms_and_conditions = /** @type {(inputs: Terms_And_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conditions générales`)
};

const es_terms_and_conditions = /** @type {(inputs: Terms_And_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos y condiciones`)
};

const ru_terms_and_conditions = /** @type {(inputs: Terms_And_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Правила и условия`)
};

const zh_terms_and_conditions = /** @type {(inputs: Terms_And_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`条款与条件`)
};

const vi_terms_and_conditions = /** @type {(inputs: Terms_And_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều khoản và điều kiện`)
};

/**
* | output |
* | --- |
* | "Terms and Conditions" |
*
* @param {Terms_And_ConditionsInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const terms_and_conditions = /** @type {((inputs?: Terms_And_ConditionsInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_And_ConditionsInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_terms_and_conditions(inputs)
	if (locale === "ja") return ja_terms_and_conditions(inputs)
	if (locale === "fr") return fr_terms_and_conditions(inputs)
	if (locale === "es") return es_terms_and_conditions(inputs)
	if (locale === "ru") return ru_terms_and_conditions(inputs)
	if (locale === "zh") return zh_terms_and_conditions(inputs)
	if (locale === "vi") return vi_terms_and_conditions(inputs)
	return en_terms_and_conditions(inputs)
});